export default "__VITE_PUBLIC_ASSET__06147658__"